// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/growth-score/components/SearchBlocks.tsx (ADAPT)
// ADAPTED: the blocks come from the view model (the BFF's scores and measured rows, our own words from `search-content.ts`)
// instead of the `searchBlocks` fixture. Not ported: the data-vendor source line and the agent checklist (TP's sample
// figures, no source of ours). The render is TP's.
/**
 * Search & AI's four blocks, each ranked against the same cohort: non-brand
 * organic, brand defense, AI visibility and agent readiness.
 */
import { Bot, Search, Shield, Sparkles, type LucideIcon } from 'lucide-react'
import { Card } from '@/components/ui/shadcn/card'
import { MAX_SCORE } from '@/contracts/onboarding-session'
import type { SearchBlock } from '../growth-score.types'
import { useGrowthScore } from '../GrowthScoreContext'
import { DimensionIcon, KvTable } from './visuals'

export const BLOCK_ICON: Record<SearchBlock['key'], LucideIcon> = { seo: Search, sem: Shield, ai: Sparkles, agent: Bot }

export function useSearchBlocks(): SearchBlock[] {
  return useGrowthScore().searchBlocks
}

export function SearchBlocks() {
  const blocks = useSearchBlocks()
  return (
    <div className="flex flex-col gap-4">
      {blocks.map((b) => (
        <Card key={b.key} className="overflow-hidden">
          <div className="flex flex-wrap items-start justify-between gap-3 p-5 pb-3">
            <div className="flex items-start gap-3">
              <DimensionIcon icon={BLOCK_ICON[b.key]} />
              <div className="flex flex-col gap-0.5">
                <h3 className="text-heading-sm text-foreground">
                  {b.name} <span className="text-body-sm text-ds-text-2">· {b.score} / {MAX_SCORE}</span>
                </h3>
                <p className="text-body-sm text-ds-text-2">
                  <span className="text-tab text-foreground">{b.gap.lead}</span> {b.gap.rest}
                </p>
              </div>
            </div>
          </div>
          <div className="px-5 pb-3">
            {b.rows.length ? (
              <KvTable rows={b.rows} caption={b.name} />
            ) : (
              <p className="text-body-sm text-ds-text-2">There are no rows for this block yet.</p>
            )}
          </div>
        </Card>
      ))}
    </div>
  )
}
